// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var List = React.forwardRef(function List(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "List" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 5H21V7H3V5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M3 11H21V13H3V11Z", fill: "currentColor" }),
            React.createElement("path", { d: "M3 17H21V19H3V17Z", fill: "currentColor" }))));
});
List.displayName = 'List';
export default List;
//# sourceMappingURL=List.js.map